<template>
  <div :class="$style.wrapper">
    <div :class="$style.wrapper__matrix">
      <div :class="$style.matrix">
        <div :class="[$style.matrix__col, $style.matrix__col_margin]">
          <matrix-card
            v-for="icon in author"
            :transparent="icon.name === null"
            :class="$style.matrix__elem"
            :style="{ background: 'rgba(255, 255, 255, 0.4)' }"
            :key="icon.id"
          >
            <template #author>
              <authorCard :name="icon.name" :icon="icon.icon" />
            </template>
          </matrix-card>
        </div>
      </div>
      <div  :class="$style.matrix">
        <slot name="body"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import authorCard from './components/author'
import matrixCard from '../matrix-card'

export default {
  name: 'wrapper-matrix',
  props: {
    author: Array,
  },
  components: {
    authorCard,
    matrixCard,
  },
}
</script>
<style scoped lang="scss" module src="./style.scss"></style>
